import React, {useEffect, useMemo, useState} from 'react';
import './App.css';
import {Spells} from "./Pages/Spells/Spells";
import {Search} from "./Pages/Search/Search";
import {PrivacyPolicy} from "./Pages/PrivacyPolicy";
import {WildMagic} from "./Pages/WildMagic/WildMagic";
import useEffectPartialDeps from "./utils/UseEffectPartialDeps";
import {SlotsAndPoints} from "./Pages/SlotsAndPoints/SlotsAndPoints";
import {getLightClericSpells} from "./Spells";
import {Menu, ToggleSwitch, RadioGroup} from 'grevlingui'

export const getStored = (key, defaultValue) => {
    const stored = localStorage.getItem(key);
    if (!stored) return defaultValue;
    return JSON.parse(stored);
}
export const getStoredString = (key, defaultValue) => {
    const stored = localStorage.getItem(key);
    return stored ?? defaultValue;
}

const getMyLocalSpells = () => {
    let s = localStorage.getItem('my-spells')
    return s ? JSON.parse(s) : [];
}

let initScrollDone, spellBookRef = React.createRef();

function App() {
    const [width, setWidth] = useState();
    const [showWildMagic, setShowWildMagic] = useState(localStorage.getItem('showWildMagic') === 'true');
    const [showSlots, setShowSlots] = useState(localStorage.getItem('showSlots') === 'true');
    const [showSorceryPoints, setShowSorceryPoints] = useState(localStorage.getItem('showSorceryPoints') === 'true');
    const [lightCleric, setLightCleric] = useState(localStorage.getItem('lightCleric') === 'true');
    const [level, setLevel] = useState(localStorage.getItem('slotsLevel') ?? 1);
    const [showBook, setShowBook] = useState(localStorage.getItem('showBook') !== 'false');
    const [showClasses, setShowClasses] = useState(localStorage.getItem('showClasses') !== 'false');
    const [showSchool, setShowSchool] = useState(localStorage.getItem('showSchool') !== 'false');
    const [activeClass, setActiveClass] = useState(getStoredString('activeClass', 'sorCleric'));
    const [mySpells, setMySpells] = useState(getMyLocalSpells());
    const [lightSpells] = useMemo(() => activeClass === 'cleric' && lightCleric ? [getLightClericSpells(level)] : [], [level, lightCleric, activeClass])

    useEffect(() => localStorage.setItem('my-spells', JSON.stringify(mySpells)), [mySpells])

    useEffect(() => {
        const extraPagesCount = [showSlots, showWildMagic].filter(t => !!t).length;
        setWidth(() => window.innerWidth * (2 + extraPagesCount));
        localStorage.setItem('showWildMagic', JSON.stringify(showWildMagic));
        localStorage.setItem('showSlots', JSON.stringify(showSlots));
    }, [showWildMagic, showSlots])

    useEffect(() => {localStorage.setItem('lightCleric', JSON.stringify(lightCleric));}, [lightCleric]);
    useEffect(() => {localStorage.setItem('showSorceryPoints', JSON.stringify(showSorceryPoints));}, [showSorceryPoints]);
    useEffect(() => {localStorage.setItem('showBook', JSON.stringify(showBook));}, [showBook]);
    useEffect(() => {localStorage.setItem('showClasses', JSON.stringify(showClasses));}, [showClasses]);
    useEffect(() => {localStorage.setItem('showSchool', JSON.stringify(showSchool));}, [showSchool]);
    useEffect(() => {localStorage.setItem('activeClass', activeClass);}, [activeClass]);

    useEffectPartialDeps(() => {
        if (mySpells && mySpells.length === 0) {
            initScrollDone = true;
            return;
        }
        if (initScrollDone || !spellBookRef.current) return;
        spellBookRef.current.scrollIntoView({behavior: "smooth"});
        initScrollDone = true;
    }, [width, mySpells])

    if (window.location.pathname === "/privacy")
        return (
            <div className={'App'}>
                <PrivacyPolicy/>
            </div>
        )
    if (!width) return <></>

    const renderMenu = () => (
        <Menu
            settings
            left
            backdropColor="#2f253de0"
            menuBgColor="#7b6c93"
        >
            <div className="menuToggles">
                <p>Class</p>
                <RadioGroup
                    onSelect={setActiveClass}
                    selected={activeClass}
                    // color={contrast}
                    options={[
                        {label: 'Sorcerer', key: 'sorcerer'},
                        {label: 'Bard', key: 'bard'},
                        {label: 'Cleric', key: 'cleric'},
                        {label: 'Ranger', key: 'ranger'}
                    ]}
                />
                {
                    activeClass === 'cleric' && (
                        <ToggleSwitch
                            active={lightCleric}
                            onChange={setLightCleric}
                            label={'Light cleric'}
                        />
                    )
                }
                <br/>
                <ToggleSwitch
                    active={showSlots}
                    onChange={setShowSlots}
                    label={'Slots page'}
                />
                <ToggleSwitch
                    active={showWildMagic}
                    onChange={setShowWildMagic}
                    label={'Wild magic page'}
                />
                <br/>
                <ToggleSwitch
                    active={showBook}
                    onChange={setShowBook}
                    label={'Show source book'}
                />
                <ToggleSwitch
                    active={showClasses}
                    onChange={setShowClasses}
                    label={'Show spell classes'}
                />
                <ToggleSwitch
                    active={showSchool}
                    onChange={setShowSchool}
                    label={'Show spell school'}
                />
            </div>
        </Menu>
    )

    return (
        <div className={'App'}>
            {renderMenu()}
            <div
                className="contentWrapper"
                style={{width}}
            >
                <Search
                    mySpells={mySpells}
                    lightCleric={activeClass === 'cleric' && lightCleric}
                    setMySpells={setMySpells}
                    showBook={showBook}
                    showClasses={showClasses}
                    showSchool={showSchool}
                />
                <Spells
                    mySpells={[...mySpells, ...(lightSpells ?? [])]}
                    setMySpells={setMySpells}
                    spellBookRef={spellBookRef}
                    lightCleric={activeClass === 'cleric' && lightCleric}
                    showBook={showBook}
                    showClasses={showClasses}
                    showSchool={showSchool}
                />
                {showSlots && (<SlotsAndPoints level={level} setLevel={setLevel} activeClass={activeClass}/>)}
                {showWildMagic && (<WildMagic/>)}
            </div>
        </div>
    );
}

export default App;
